
import { viewSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListViewSelect";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

viewSelectStyles.wrapper = {
	css: css`
		${({ theme }: { theme: BaseTheme }) =>
			breakpointMediaQueries(theme, [
				css`
					display: none;
				`,
				css`
					display: none;
				`,
				css`
					display: flex;
					padding-top: 5px;
					float: right;
				`,
				css`
					display: flex;
					padding-top: 5px;
					float: right;
				`,
				css`
					display: flex;
					padding-top: 5px;
					float: right;
				`,
        ])}
    `,
}